import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { DigitalMenuShareApi, FindDigitalMenuSharesOption } from 'api';

export const findDigitalMenuSharesToShare = createAsyncThunk(
  'digitalMenuShare/findDigitalMenuSharesToShare',
  async (
    {
      digitalMenuID,
    }: {
      digitalMenuID: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await DigitalMenuShareApi.findDigitalMenuSharesToShare(
        digitalMenuID
      );

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findDigitalMenuShares = createAsyncThunk(
  'digitalMenuShare/findDigitalMenuSharesToShare',
  async (options: FindDigitalMenuSharesOption, { rejectWithValue }) => {
    try {
      const response = await DigitalMenuShareApi.findDigitalMenuShares(options);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface DigitalMenuShareState {
  data: any[];
}

const initialState: DigitalMenuShareState = {
  data: [],
};

const digitalMenuShareSlice = createSlice({
  name: 'digitalMenuShare',
  initialState,
  reducers: {},
  //   extraReducers: builder => {},
});

const { reducer: digitalMenuShareReducer } = digitalMenuShareSlice;

export default digitalMenuShareReducer;
